export const styles = `
	<style>
		html:has(wdk-dialog dialog[open]) {
			overflow: hidden;
		}
				
		/* Just to make the Component "visible" to Tests. So we don't have to check for the real dialog Element in here */
		wdk-dialog:has(dialog[open]) {
			position: fixed;
    		inset: 0;
		}
		
		wdk-dialog {
			--wdk-dialog-width-desktop: 560px;
		}
		/*
		--BREAKPOINT_S: 320px;
		--BREAKPOINT_M: 601px;
		--BREAKPOINT_L: 768px;
		--BREAKPOINT_XL: 980px;
		*/
	
		 /* 
		don't change anything about height and width 
		-> this was evil to get it work in all variants 
		(long text, short text, only one word text etc., mobile, desktop, mobile-full-height and not mobile-full-height
		*/
		wdk-dialog dialog {
			inset: 0;
			width: 100%;
			max-width: 100%;
			max-height: 80dvh;
			overflow: hidden;
			border: none;
			padding: 0;
			margin-block-end: 0;
			background-color: transparent;
			transition: display .5s allow-discrete, overlay .5s allow-discrete;
			animation: close .5s forwards;
		}

		/*Close Animation Safari iOS ist holperig. Der innere Teil bleibt komisch stehen */
		html.macSafari wdk-dialog dialog,
		html.ios wdk-dialog dialog {
			transition: none;
		}
		
		wdk-dialog[open] dialog {
			animation: open .5s forwards;
		}
		
		@media only screen and (min-width: 601px) {
			wdk-dialog dialog {
				max-width: none;
				width: var(--wdk-dialog-width-desktop);
				margin-bottom: auto;
			}
		}
		
		wdk-dialog[mobile-full-height] dialog {
			height: 100dvh;
			max-height: 100dvh;
		}
		
		@media only screen and (min-width: 601px) {
			wdk-dialog[mobile-full-height] dialog {
				height: fit-content;
				max-height: 80dvh;
			}
		}

		@media only screen and (max-width: 600px) {
			wdk-dialog[mobile-center] dialog {
				margin-block-end: auto;
				padding-inline: 8px;
			}
		}
				 
		wdk-dialog dialog[open]::backdrop {
			backdrop-filter: blur(16px);
			-webkit-backdrop-filter: blur(16px);
			background-color: #00000A99; /* 99 = 60% opacity -> Safari has a bug with vars for background-color on backdrop*/
		}
		
		wdk-dialog[no-backdrop] dialog::backdrop {
			background-color: transparent;
			backdrop-filter: blur(0);
			-webkit-backdrop-filter: blur(0);
		}
		
		wdk-dialog[closing-x="inside"] dialog .closingX {
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			z-index: 1;
			top: 20px;
			right: 20px;
			height: 32px;
			width: 32px;
			padding: 0;
			border: 0;
			cursor: pointer;
			background-color: transparent;
		}
		
		wdk-dialog[closing-x="inside"] dialog .closingX:hover {
			opacity: .5;
		}
		
		wdk-dialog[closing-x="inside"] dialog .closingX svg {
			display: block;
			width: 32px;
			height: 32px; 
		}

		wdk-dialog[closing-x="inside"] dialog .closingX svg line {
			stroke: var(--wdk-dialog-closing-x-color, var(--COLOR_support_black_default));
			stroke-width: 1.8px;
		}

		wdk-dialog[closing-x="outside"] dialog {
			padding-bottom: 100px;
		}

		@media only screen and (min-width: 601px) {
			wdk-dialog[closing-x="outside"] dialog {
				padding-bottom: 50px;
			}
		}
		
		wdk-dialog[closing-x="outside"] dialog .closingX {
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			bottom: 20px;
			left: calc(50% - 16px);
			height: 32px;
			width: 32px;
			padding: 0;
			background-color: transparent;
			border: 0;
			border-radius: 30px;
			cursor: pointer;
		}
		
		@media only screen and (min-width: 601px) {
			wdk-dialog[closing-x="outside"] dialog .closingX {
				bottom: 0;
			}
		}
		
		wdk-dialog[closing-x="outside"] dialog .closingX:hover {
			opacity: .5;
		}
		
		wdk-dialog[closing-x="outside"] dialog .closingX svg {
			display: block;
			height: 32px;
			width: 32px;
		}
		
		wdk-dialog[closing-x="outside"] dialog .closingX svg line {
			stroke: var(--COLOR_support_white_default);
			stroke-width: 1.8px;
		}
		
		wdk-dialog dialog:has(.wdk-loadingSpinner) {
			display: flex;
			justify-content: center;
			padding-bottom: 32px;
		}
		
		wdk-dialog dialog:has(wdk-dialog-body-freestyle) {
			overflow-y: auto;
		}
		
		@keyframes open {
			from {
				opacity: 0;
				transform: translateY(100%);
			}
			to {
				opacity: 1;
				transform: translateY(0);
			}
		}
		
		@keyframes close {
			from {
				opacity: 1;
				transform: translateY(0);
			}
			to {
				opacity: 0;
				transform: translateY(100%);
			}
		}
		
	</style>
`;
